import React from 'react';
import PropTypes from 'prop-types';
import {RenderHTML} from '@learningblocks/shared-components';
import {Highlighter} from './Highlighter';
import { domToReact } from 'html-react-parser';

const HIGHLIGHT_TAG = 'highlight';

/**
 * HighligthHTML
 *  - Highlighting component that will highlight
 *    a particular string passes in as <highlight/>
 *    tag in html string.
 */
export function HighlightHTML(props) {
  const addHighlight = (node) => {
    if (node.name === HIGHLIGHT_TAG) {
      return (
        <Highlighter
          node={node}
          contentID={node.attribs.contentid}
          getContentData={props.getContentData}
          openGlossary={props.openGlossary}>
          {domToReact(node.children)}
        </Highlighter>
      );
    }
  };

  return <RenderHTML content={props.content} replace={addHighlight} />;
}

HighlightHTML.propTypes = {
  /**
   * String value containing markup <highlight> to handle highlighting
   */
  content: PropTypes.object.isRequired,
  /**
   * Async function to fetch data for highlight content data
   */
  getContentData: PropTypes.func.isRequired,
  /**
   * Function involked when you wanna open glossary from tooltip
   */
  openGlossary: PropTypes.func.isRequired,
};

HighlightHTML.defaultProps = {
  content: '',
};
